import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Button } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import styled from 'styled-components';
import { connect } from '../../Store';
import { __, round } from '../../Utils';
import { FlexBox, H2, SegmentWrapper } from '../ReusableComponents';
import Table from '../Table';

const MainWrapper = styled.div`
  width: auto;
  height: auto;
  justify-content: center;
  align-items: ${props => (props.alignUnderHeader ? 'flex-start' : 'center')};
  display: flex;
  position: fixed;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  z-index: 8009;
  background: rgba(35, 33, 33, 0.75);
  padding: ${rem(135)} ${rem(30)} ${rem(30)} ${rem(30)};
`;

const PopupWrapper = styled.div`
  position: fixed;
  top: 7%;
  padding-bottom: 15px;
  overflow-y: auto;
  background: white;
  width: 100%;
  z-index: 8011;
  /* ${({ theme }) => theme.media.s`
  width: ${props => (props.fullwidth ? '90%' : rem(500))};
`}; */
  max-width: ${props => (props.fullWidth ? '90%' : rem(800))};
`;

const CustomSegmentWrapper = styled(SegmentWrapper)`
  position: sticky;
  top: 0;
  background: #f7ffe8;
  z-index: 2;
  div {
    padding: ${rem(5)};
  }
`;

const Flex = styled(FlexBox)`
  justify-content: space-between;
  padding: 0;
`;

const CustomH2 = styled(H2)`
  padding-left: ${rem(10)};
`;

const TableWrapper = styled.div`
  margin: ${rem(15)};
  padding-bottom: ${rem(20)};
  font-size: 14px;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: ${rem(15)};
`;
const ButtonTableRow = styled.div`
  display: flex;
  justify-content: center;
`;

const Close = styled.img`
  cursor: pointer;
`;

class PriceOffersPopup extends React.Component {
  createColumns() {
    return [
      {
        accessor: 'project_name',
        Header: () => {
          return __('Názov projektu');
        },
        Cell: props => {
          return props.value ? props.value : '-';
        },
      },
      {
        accessor: 'discount',
        Header: () => {
          return __('Zľava %');
        },
        Cell: props => {
          return props.value ? props.value : '-';
        },
      },
      {
        accessor: 'price',
        Header: () => {
          return __('Cena za ks');
        },
        Cell: props => {
          return props.value ? props.value : '-';
        },
      },
      {
        accessor: 'price_vat',
        Header: () => {
          return __('Cena za ks s DPH');
        },
        Cell: props => {
          return props.value ? props.value : '-';
        },
      },
      {
        accessor: 'quantity',
        Header: () => {
          return __('Množstvo');
        },
        Cell: props => {
          return props.value ? props.value : '-';
        },
      },
      {
        accessor: '_id',
        maxWidth: 100,
        Header: () => {
          return '';
        },
        Cell: () => {
          return (
            <ButtonTableRow>
              <Button primary>{__('Zvoľ')}</Button>
            </ButtonTableRow>
          );
        },
      },
    ];
  }

  normalizeData(data) {
    const { selectedQuantity } = this.props;

    const filteredData = data.filter(
      d =>
        (d.quantity === -1 && selectedQuantity >= (d.minimal_quantity || 0)) ||
        selectedQuantity <= d.quantity,
    );
    return filteredData.map(d => {
      return {
        _id: d._id,
        project_name: d.project_name,
        discount: `${d.product_custom_discount_percent} %`,
        price: `${round(d.price.amount, 2)} ${d.price.currency}`,
        price_vat: `${round(d.price_vat.amount, 2)} ${d.price_vat.currency}`,
        quantity: d.quantity === -1 ? __('neobmedzené') : d.quantity,
      };
    });
  }

  render() {
    const {
      onClose,
      onSubmit,
      display,
      styles,
      fullWidth,
      priceOffers,
    } = this.props;

    const priceOffersLen = this.normalizeData(priceOffers).length;

    return display ? (
      <MainWrapper alignUnderHeader>
        <PopupWrapper style={styles} fullWidth={fullWidth}>
          <CustomSegmentWrapper>
            <Segment secondary>
              <Flex>
                <CustomH2>
                  {priceOffersLen > 1
                    ? __('Na tento produkt máte vytvorené cenové ponuky')
                    : __('Na tento produkt máte vytvorenú cenovú ponuku')}
                </CustomH2>
                <Close
                  onClick={() => onClose()}
                  src="/images/icons/close_transparent.svg"
                  height="32px"
                />
              </Flex>
            </Segment>
          </CustomSegmentWrapper>
          <TableWrapper>
            <Table
              columns={this.createColumns()}
              minWidth={100}
              data={this.normalizeData(priceOffers)}
              pageSize={priceOffersLen}
              loadingColor="#70af00"
              offset={120}
              getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row) {
                  return {
                    onClick: () => onSubmit(rowInfo.original._id),
                    style: {
                      cursor: 'pointer',
                      'align-items': 'baseline',
                    },
                  };
                }
                return {};
              }}
              className="-highlight"
              style={{
                border: 'unset',
              }}
            />
          </TableWrapper>
          <ButtonRow>
            <Button onClick={() => onSubmit('WITHOUT')} primary>
              {__('Pridať bez cenovej ponuky')}
            </Button>
          </ButtonRow>
        </PopupWrapper>
      </MainWrapper>
    ) : (
      <React.Fragment />
    );
  }
}

PriceOffersPopup.propTypes = {
  styles: PropTypes.object, //eslint-disable-line
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  fullWidth: PropTypes.bool,
  priceOffers: PropTypes.arrayOf({}),
  display: PropTypes.bool,
  selectedQuantity: PropTypes.number,
};

PriceOffersPopup.defaultProps = {
  styles: {},
  onSubmit: () => {},
  display: false,
  fullWidth: false,
  priceOffers: [],
  selectedQuantity: 0,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(PriceOffersPopup);



// WEBPACK FOOTER //
// ./src/Components/PriceOffersPopup/index.jsx